import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CircularProgress from '../../../../components/CircularProgress';
import { GetArchivedData } from "../../../../appRedux/actions/BalanceSheetAction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';


import moment from 'moment';
import { toast } from 'react-toastify';
import './style.css';


class ArchivedBalanceSheetsComponent extends Component {

    constructor(props) {

        super(props)

        this.sDateRef = React.createRef();
        this.eDateRef = React.createRef();
        let endDate = new Date();
        // let fromDate = new Date(endDate.getFullYear() - 1, 0, 1);
        const fromDate = new Date(endDate.getFullYear(), 0, 1);
        
        this.state = {
            loading: false,
            companyId: 0,
            lst_data: [],
            sDate: fromDate,
            eDate: endDate,
            PageNo: 1,
            PageSize: 500
        }
    }

    ApplyDate = () => {
        this.setState({
            loading: true,
        }, () => {
            this.GetReportData()
        });
    }

    handleFocus = (e, selecter) => {
        let control = null;
        if (selecter !== undefined) {
            if (selecter === "sDate") {
                control = this.sDateRef;
                if (control.current != null) {
                    control.current.setFocus();
                }
            }
            else if (selecter === "eDate") {
                control = this.eDateRef;
                if (control.current != null) {
                    control.current.setFocus();
                }
            }
        }
    }
    handleDateChange = (e, target) => {

        if (target === "fromDate") {

            this.setState({ sDate: new Date(e), selectedDateRange: { startDate: moment(new Date(e)).format("MM/DD/YYYY"), endDate: moment(this.state.eDate).format("MM/DD/YYYY") } })
        }
        else if (target === "uptoDate") {
            this.setState({ eDate: new Date(e), selectedDateRange: { startDate: moment(this.state.sDate).format("MM/DD/YYYY"), endDate: moment(new Date(e)).format("MM/DD/YYYY") } })
        }
    }

    BackToReport = () =>{
        this.props.history.push("trialBalanceReview");
    }

    componentWillReceiveProps(nextprops) {

        if (nextprops.ArchivedData!==undefined && this.props.ArchivedData !== nextprops.ArchivedData) {
            if (nextprops.ArchivedData.transactionStatus === 0 && nextprops.ArchivedData.returnObject != null) {
                this.setState({ loading: false, lst_data: nextprops.ArchivedData.returnObject });
            }
            else {
                this.setState({ loading: false }, () => { toast.error(nextprops.ArchivedData.resultMsg) });
            }
        }
        /* No blanket `else { loading: false }`: any prop change would drop the spinner
           mid-fetch and flash "No Data Found". Only the response clears loading. */
    }

    componentDidMount() {
        let user = JSON.parse(localStorage.getItem('userData'));
        this.setState({ loading: true, companyId: user.companyId }, () => {
            this.GetReportData()
        });
    }

    GetReportData = () => {
        let statedata = this.state;
        let body = {
            "companyID": statedata.companyId,
            "pageNumber": statedata.PageNo,
            "pageSize": statedata.PageSize,
            "fromDate": moment(statedata.sDate).format("MM/DD/YYYY"),
            "toDate": moment(statedata.eDate).format("MM/DD/YYYY"),
        }
        this.props.GetArchivedData(body);
    }


    render() {

        return (
            <div className="dashboardPage balance-sheet-history-page">
                <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h2 className="title mb-sm-0 balance-sheet-history-title">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | Balance Sheet Review History</h2>
                </div>
                {this.state.loading ?
                    <div className="bs-loading-wrap balance-sheet-history-loader">
                        <CircularProgress />
                    </div>
                    :
                <div className="padding-box app-wrapper padding-b0 bs-review-screen bs-review-history-page">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="select-quater-box">
                                <p className="sub-title">Reviewed Balance Sheets</p>
                                <div className="row">
                                    <div className="col-sm-4 col-md-12 ">
                                        <div className="datepicker-box">
                                            <div className="date-box">
                                                <DatePicker
                                                    selected={this.state.sDate}
                                                    onChange={(e) => this.handleDateChange(e, 'fromDate')}
                                                    name="fromDate"
                                                    id="date"
                                                    required={true}
                                                    margin="normal"
                                                    disabledKeyboardNavigation
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={15}
                                                    popperModifiers={{
                                                        preventOverflow: { enabled: true, boundariesElement: 'viewport' },
                                                        flip: { enabled: true }
                                                    }}
                                                    maxDate={this.state.eDate}
                                                    ref={this.sDateRef}
                                                />
                                                <div className="date-icon" onClick={(e) => this.handleFocus(e, 'sDate')}>
                                                    <i className="zmdi zmdi-calendar-note"></i>
                                                </div>
                                            </div>
                                            <div className="to-box">
                                                <span className="text-center ledgerto-text">To</span>
                                            </div>
                                            <div className="date-box">
                                                <DatePicker
                                                    selected={this.state.eDate}
                                                    onChange={(e) => this.handleDateChange(e, 'uptoDate')}
                                                    name="uptoDate"
                                                    id="date"
                                                    required={true}
                                                    margin="normal"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    yearDropdownItemNumber={15}
                                                    disabledKeyboardNavigation
                                                    popperModifiers={{
                                                        preventOverflow: { enabled: true, boundariesElement: 'viewport' },
                                                        flip: { enabled: true }
                                                    }}
                                                    minDate={this.state.sDate}
                                                    maxDate={new Date()}
                                                    ref={this.eDateRef}
                                                />
                                                <div className="date-icon" onClick={(e) => this.handleFocus(e, 'eDate')}>
                                                    <i className="zmdi zmdi-calendar-note"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="genera-apply-btn balance-sheet-history-apply">
                                            <Button variant="contained" className="greencolor jr-btn bg-teal text-white refresh-btn" onClick={(e) => this.ApplyDate()} >Apply</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-9">
                            <div className="float-right"> 
                                <Button className="greencolor jr-btn bg-teal text-white refresh-btn view-btn" onClick={(e) => this.BackToReport()} >Back</Button>
                            </div>
                        </div>
                    </div>
                    <div className="row balance-sheet-history-table-row">
                        <div className="table-responsive balance-sheet-history-table-wrap">
                            <table className="table balance-sheet-history-table">
                                <thead>
                                    <tr className="header-bg-color archived_sheets">
                                        <th className="balance-sheet-history-col-details">Details</th>
                                        <th className="balance-sheet-history-col-date">Reviewed On</th>
                                        <th className="balance-sheet-history-col-user">Reviewed By</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.lst_data != null && this.state.lst_data.length > 0 ?
                                        this.state.lst_data.map((item, index) => (
                                            <tr key={item.id != null ? item.id : `archived-bs-${index}`}>
                                                <td className="balance-sheet-history-col-details">
                                                    <Link className="balance-sheet-history-link" to={{ pathname: '/trialBalanceReview', state: { ArchivedData: item } }}>{item.details}</Link>
                                                </td>
                                                <td className="balance-sheet-history-col-date">{item.stArchiveDate}</td>
                                                <td className="balance-sheet-history-col-user">{item.userName}</td>
                                            </tr>
                                        ))
                                        :
                                        <tr>
                                            <td colSpan="3" className="text-center balance-sheet-history-empty"> No Data Found </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        ArchivedData: state.BalanceSheetData.ArchivedData
    }
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GetArchivedData
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ArchivedBalanceSheetsComponent);